<template>
  <a-modal v-model="visible" title="画廊" @ok="handleOk" width="660px">
    <a-row>
      <a-col span="6" v-for="(img, index) in imgList" :key="img.id">
        <TextbookMakerUpload :key="img.id" :defaultUrl="img.src" :path="`textbook/${textbook.id}/${unit.folderName}/images/`" @changeImgUrl="(uri) => changeImgUrl(index, uri)"/>
      </a-col>
    </a-row>
    <a-input v-model="text" style="width: 100%"/>
    <a-button block @click="addImg">添加图片</a-button>
</a-modal>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import TextbookMakerUpload from '@/components/TextbookMakerUpload.vue'
export default {
  name: 'Gallery1',
  components: {
    TextbookMakerUpload
  },
  data() {
    return {
      visible: false,
      imgList: [],
      text: undefined
    }
  },
  computed: {
    ...mapState({
      textbook: (state) => {
        return state.textbookMaker.textbook
      },
      unit: (state) => {
        return state.textbookMaker.unit
      },
      lesson: (state) => {
        return state.textbookMaker.lesson
      },
    })
  },
  methods: {
    open() {
      this.visible = true
      console.log(this.textbook)
    },
    addImg() {
      this.imgList.push({
        id: this.imgList.length + 1,
        src: undefined
      })
    },
    changeImgUrl(index, imgUrl) {
      console.log(index, imgUrl)
      this.imgList[index].src = imgUrl
    },
    handleOk() {
      console.log(this.imgList)
      let jsonStr = JSON.stringify(this.imgList)
      console.log(jsonStr)
      let content = '<div class="mceNonEditable gallery-template-1" data-json='+ jsonStr +'><img src="' + this.imgList[0].src + '"/><div class="img_caption">'+this.text+'</div></div>'
      this.$emit('ok', {content: content, data: this.imgList})
      this.visible = false
    }
  }
}
</script>

<style>

</style>